import React, { Component } from 'react';
import { action } from 'mobx';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';
import withAppStore from 'decorators/withAppStore';
import Tooltip from 'material-ui/Tooltip';
import IconButton from 'material-ui/IconButton';
import { FileTree } from 'mdi-material-ui';
import Code from 'components/Code';
import styles from 'styles/components/CodeInfo';

@withStyles(styles)
@withAppStore
@observer
export default class ReturnToTree extends Component {
    render() {
        return (<Tooltip disableTriggerFocus={true} title={<Code code={this.props.code} id={this.props.id} />} placement='left'>
            <IconButton onClick={() => this.handleTreeLinkClick()} >
                {
                    <FileTree />
                }
            </IconButton>
        </Tooltip>) || (this.appStore.treeLink === null && <Code code={this.props.code} />);
    }

    @action.bound
    handleTreeLinkClick() {
        var originSelfHref = this.appStore.treeLink ? this.appStore.treeLink : this.appStore.widgetOrigin;
        const { tnved } = this.props;
        const id = this.props.id;
        var id_str = ''
        if (originSelfHref){
            if (tnved) {
                for (let index = 0; index < tnved.length; index++) {
                    id_str += tnved[index].id + ';'
                    if (tnved[index].id === id) break;
                }
            }
            if (originSelfHref.substr(-1) !== '/') originSelfHref += '/';
            if (originSelfHref.indexOf('/web') !== -1) {
                originSelfHref += `search-open=false`;
            }
            else {
                originSelfHref += `#search-open=false`
            }
    
            if (id !== 0) {
                originSelfHref += `&expanded=${id_str.slice(0, -1)}`
                originSelfHref += `&info-code=null`
            }
    
            if (this.appStore.treeLinkTarget === null && window.parent) {
                try {
                    window.open(originSelfHref,'_top');  
                }
                catch (err) {
                    console.log(`${err}`)
                }
            }
            else {
                window.open(originSelfHref, this.appStore.treeLinkTarget);
            }
    
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/ReturnToTree.js